import { render, staticRenderFns } from "./OtherInModal.vue?vue&type=template&id=270f255e&scoped=true"
import script from "./OtherInModal.vue?vue&type=script&lang=js"
export * from "./OtherInModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270f255e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('270f255e')) {
      api.createRecord('270f255e', component.options)
    } else {
      api.reload('270f255e', component.options)
    }
    module.hot.accept("./OtherInModal.vue?vue&type=template&id=270f255e&scoped=true", function () {
      api.rerender('270f255e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/bill/modules/OtherInModal.vue"
export default component.exports